(function () {
  function initStoreLocator(root) {
    const mapEl = root.querySelector('#leafletMap');
    const listEl = root.querySelector('#storeList');
    const searchEl = root.querySelector('#storeSearch');
    const locateBtn = root.querySelector('#locateMe');

    if (!mapEl || !listEl) return;

    if (!window.L) {
      listEl.innerHTML = '<p>Map library failed to load.</p>';
      return;
    }

    const storesUrl = root.dataset.storesUrl;

    const map = L.map(mapEl, { scrollWheelZoom: true });

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    const markers = new Map();

    // Only allow real http(s) links for retailer websites
    function safeUrl(url) {
      if (!url || typeof url !== 'string') return '';
      const u = url.trim();
      return /^https?:\/\//i.test(u) ? u.replace(/"/g, '%22') : '';
    }

    function haversineKm(a, b) {
      const toRad = (d) => (d * Math.PI) / 180;
      const R = 6371;
      const dLat = toRad(b.lat - a.lat);
      const dLng = toRad(b.lng - a.lng);
      const s1 = Math.sin(dLat / 2) ** 2;
      const s2 =
        Math.cos(toRad(a.lat)) *
        Math.cos(toRad(b.lat)) *
        (Math.sin(dLng / 2) ** 2);
      return 2 * R * Math.asin(Math.sqrt(s1 + s2));
    }

    function renderList(stores) {
      listEl.innerHTML = '';
      stores.forEach((s) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.innerHTML = `
          <strong>${s.name ?? 'Store'}</strong><br>
          <span>${s.address ?? ''}</span><br>
          ${
            s.distanceKm != null
              ? `<br><small>${s.distanceKm.toFixed(1)} km away</small>`
              : ``
          }
        `;
        btn.addEventListener('click', () => {
          const m = markers.get(s.id);
          if (m) {
            map.setView(m.getLatLng(), 14);
            m.openPopup();
          }
        });
        listEl.appendChild(btn);
      });
    }

    function applyFilter(allStores) {
      if (!searchEl) return renderList(allStores);

      const q = (searchEl.value || '').trim().toLowerCase();
      const filtered = !q
        ? allStores
        : allStores.filter(
            (s) =>
              (s.name || '').toLowerCase().includes(q) ||
              (s.address || '').toLowerCase().includes(q)
          );

      renderList(filtered);

      allStores.forEach((s) => {
        const m = markers.get(s.id);
        if (!m) return;
        if (!q || filtered.includes(s)) m.addTo(map);
        else map.removeLayer(m);
      });
    }

    fetch(storesUrl)
      .then((r) => r.json())
      .then((stores) => {
        stores.forEach((s) => {
          const m = L.marker([s.lat, s.lng])
            .addTo(map)
            .bindPopup(`
              <strong>${s.name ?? ''}</strong><br>
              ${s.address ?? ''}<br>
              ${s.phone ? `<a href="tel:${s.phone}">${s.phone}</a><br>` : ``}
              ${safeUrl(s.url) ? `<a class="store-locator__website" target="_blank" rel="noopener" href="${safeUrl(s.url)}">Visit website</a><br>` : ``}
              ${s.hours ? `<small>${s.hours}</small><br>` : ``}
              <a target="_blank" rel="noopener"
                 href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                   `${s.lat},${s.lng}`
                 )}">
                Directions
              </a>
            `);

          markers.set(s.id, m);
        });

        //const bounds = L.latLngBounds(stores.map((s) => [s.lat, s.lng]));
        //map.fitBounds(bounds.pad(0.2));

        map.setView([-25.2744, 133.7751], 4);

        renderList(stores);

        if (searchEl) searchEl.addEventListener('input', () => applyFilter(stores));

        if (locateBtn) {
          locateBtn.addEventListener('click', () => {
            if (!navigator.geolocation) return;

            navigator.geolocation.getCurrentPosition(
              (pos) => {
                const user = {
                  lat: pos.coords.latitude,
                  lng: pos.coords.longitude
                };

                const sorted = stores
                  .map((s) => ({
                    ...s,
                    distanceKm: haversineKm(user, { lat: s.lat, lng: s.lng })
                  }))
                  .sort((a, b) => a.distanceKm - b.distanceKm);

                L.circleMarker([user.lat, user.lng], { radius: 8 })
                  .addTo(map)
                  .bindPopup('You are here')
                  .openPopup();

                renderList(sorted);
                map.setView([user.lat, user.lng], 11);
              },
              () => {}
            );
          });
        }
      })
      .catch(() => {
        listEl.innerHTML = '<p>Could not load store locations.</p>';
        map.setView([0, 0], 2);
      });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.store-locator-root').forEach((root) => {
      initStoreLocator(root);
    });
  });
})();